(ns dre.pages.admin.help.views
  (:require
   [dre.components.collapsable-panel :refer [collapsable-panel]]
   [dre.components.icon :refer [icon]]
   [dre.components.loading-spinner :refer [loading-spinner]]
   [dre.components.table :refer [table]]
   [dre.modals.events :as-alias modals]
   [dre.pages.admin.views :refer [nav-tabs]]
   [dre.pages.admin.help.events :as-alias admin-help]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def component-name :admin-help)

(defn- topic-panel-table
  [{:keys [confluence-id datasource]}]
  (let [help-topic confluence-id]
    [table
     {:columns [{:title "Title"
                 :dataIndex :title}
                {:title "Confluence ID"
                 :render (fn [{:keys [confluence-id]}]
                           [:a {:target :_blank
                                :href (str "https://confluence.doctorevidence.com/display/shareit/" confluence-id)}
                            confluence-id])}
                {:title "Actions"
                 :render (fn [{:keys [confluence-id]}]
                           [:a {:href "#"
                                :style {:color :red
                                        :font-weight 1000}
                                :on-click #(rf/dispatch [::admin-help/delete-article
                                                         {:help-topic help-topic
                                                          :confluence-id confluence-id}])}
                            [icon :common :dismiss]])}]
      :dataSource datasource
      :drag-sortable? true
      :on-drag-end #(rf/dispatch [::admin-help/on-drag-end {:help-topic help-topic
                                                            :drag-params %}])}]))

(defn- topic-panel
  [{:keys [confluence-id] :as opts}]
  [collapsable-panel
   {:title confluence-id
    :actions (fn [] [:<>
                     [:button
                      {:class (bem/bm :button :small)
                       :on-click #(rf/dispatch [::modals/set-modal :admin.help/add-confluence-article
                                                {:add-confluence-article
                                                 {:help-topic confluence-id
                                                  :confluence-id ""
                                                  :title ""}}])}
                      "Add Confluence article"]
                     [:button
                      {:class (bem/bm :button :small)
                       :on-click #(rf/dispatch [::modals/set-modal :admin.help/preview-help-topic
                                                {:preview-help-topic {:confluence-id confluence-id
                                                                      :loading? true}}])}
                      "Preview"]
                     [:button
                      {:class (bem/bm :button :small)
                       :on-click #(rf/dispatch [::modals/set-modal :admin.help/delete-help-topic
                                                {:delete-help-topic {:confluence-id confluence-id}}])}
                      "Delete"]])
    :content (fn [] [topic-panel-table opts])}])

(defn- panels
  [topics]
  [:div
   {:class (bem/be component-name :panels)}
   (map (fn [{:keys [confluence-id] :as data}]
          ^{:key confluence-id}
          [topic-panel data])
        topics)])

(defn view
  []
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :nav)}
    [nav-tabs]]
   [:div
    {:class (bem/be component-name :header)}
    [:div
     {:class (bem/be component-name :info-block)}
     "Move panels up and down to change the order in which topics appear in the general help page."
     [:br]
     "Move rows up and down to change the order in which Confluence articles will appear in a single help modal."
     [:br]
     "Click on the preview button to preview the help content."
     [:br]]
    [:div
     {:class (bem/be component-name :actions)}
     [:button.button
      {:on-click #(rf/dispatch [::modals/set-modal :admin.help/add-help-topic {:add-help-topic {:confluence-id ""}}])}
      "Add Help Topic"]]]
   (if @(rf/subscribe [::admin-help/loading?])
     [loading-spinner]
     [panels @(rf/subscribe [::admin-help/topics])])])
